module.exports = __webpack_public_path__ + "img/landing-golf.7e4ace38.png";